<template> 
<div>
<span v-if="this['1999'] && this['2019']"> En 1999 dans la ville aéroportuaire de {{ville}},  
le nombre de flux aériens de plus de 5000 passagers par an était de {{data1999.nb_flux_in}} entrant(s) pour {{data1999.nb_flux_out}} sortant(s) <br>
Pour, en 2019, passer à {{data2019.nb_flux_in}} entrant(s) pour {{data2019.nb_flux_out}} sortant(s) <br><br>
Ce qui représente une <b v-if="data2019.sommedestination>data1999.sommedestination"> augmentation de {{data2019.sommedestination - data1999.sommedestination}}</b>
<b v-else-if="data2019.sommedestination<data1999.sommedestination"> baisse de {{data2019.sommedestination - data1999.sommedestination}}</b> <b v-else> stagnation à 0 du nombre de </b> passagers entrants,
ainsi qu'une <b v-if="data2019.sommeorigine>data1999.sommeorigine"> augmentation de {{data2019.sommeorigine - data1999.sommeorigine}}</b>
<b v-else-if="data1999.sommeorigine>data2019.sommeorigine"> baisse de {{data2019.sommeorigine - data1999.sommeorigine}}</b> <b v-else> stagnation à 0 du nombre de </b> passagers sortants.
</span>
<span v-else-if="this['1999']"> En 1999 dans la ville aéroportuaire de {{ville}},  
le nombre de flux aériens de plus de 5000 passagers par an était de {{data1999.nb_flux_in}} entrant(s) pour {{data1999.nb_flux_out}} sortant(s) <br>
Pour, en 2019, ne plus avoir de flux entrants ni de flux sortants<br><br>
Ce qui représente une <b v-if="data1999.sommedestination>0"> baisse de {{data1999.sommedestination}} passagers entrants</b><b v-else> stagnation à 0</b>,
ainsi qu'une <b v-if="data1999.sommeorigine>0"> baisse de {{data1999.sommeorigine}}</b> <b v-else> stagnation à 0 du nombre de </b> passagers sortants.
</span>
<span v-else-if="this['2019']"> En 1999 dans la ville aéroportuaire de {{ville}},  
il n'y avait aucun flux aérien de plus de 5000 passagers par an, entrant ou sortant <br>
Mais en 2019, ils sont passés à {{data2019.nb_flux_in}} entrant(s) pour {{data2019.nb_flux_out}} sortant(s) <br><br>
Ce qui représente une <b v-if="data2019.sommedestination>0"> augmentation de {{data2019.sommedestination}} </b><b v-else> stagnation à 0 du nombre de </b> passagers entrants,
ainsi qu'une <b v-if="data2019.sommeorigine>0"> augmentation de {{data2019.sommeorigine}}</b> <b v-else> stagnation à 0 du nombre de </b> passagers sortants.
</span>
<span v-else> Si en 1999 il n'y avait aucun flux aérien de plus de 5000 passagers par an à {{ville}}, il n'y en a pas eu plus en 2019
</span>
</div>
</template>

<script>
import dataAllYearsDgaf from "../data/all_years_dgaf.json"
export default {
    props: {
    selected: {
      type: String,
    },
  },
    data(){
        return {
            dataAllYears:null,
            ville: null,
            year: null,
            "1999": null,
            "2019": null,
            data2019: null,
            data1999: null,
        }
    },
    created(){
      this.ville = this.$props.selected;
      this.dataAllYears = dataAllYearsDgaf.filter((e)=>{
           return (e.annee == "1999" || e.annee == "2019") && e.ville == this.ville
      });
    },
    mounted() {
      this["1999"]= null;
      this["2019"]= null;
      this.data2019 = null;
      this.data1999= null;
      for(let i in this.dataAllYears){
        if(this.dataAllYears[i]["nb_flux_in"] || this.dataAllYears[i]["nb_flux_out"]){
          this[this.dataAllYears[i].annee] = 1;
          this["data"+this.dataAllYears[i].annee] = this.dataAllYears[i];
          if(!this["data"+this.dataAllYears[i].annee].nb_flux_in){
            this["data"+this.dataAllYears[i].annee].nb_flux_in = 0;
          }
          else if(!this["data"+this.dataAllYears[i].annee].nb_flux_out){
            this["data"+this.dataAllYears[i].annee].nb_flux_out = 0;
          }
        }
      }
    },
};
</script>

<style></style>
